var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinInButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#pin-in-button_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pin-in-button_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.5 16.803C29.5 24 20 33 20 33s-9.5-9-9.5-16.197C10.5 11.39 14.753 7 20 7s9.5 4.39 9.5 9.803"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FF3118",
  d: "M29.5 16.803C29.5 24 20 33 20 33s-9.5-9-9.5-16.197C10.5 11.39 14.753 7 20 7s9.5 4.39 9.5 9.803"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m20 33-.688.726.688.651.688-.651zm8.5-16.197c0 1.592-.53 3.35-1.386 5.134-.852 1.777-2 3.519-3.162 5.061a49 49 0 0 1-4.542 5.182l-.075.072-.018.018-.004.003v.001L20 33l.688.726v-.001l.003-.002.006-.006.023-.021.084-.082q.11-.106.312-.308a50.65 50.65 0 0 0 4.433-5.103c1.211-1.607 2.44-3.465 3.368-5.4.925-1.927 1.583-3.993 1.583-6zM20 33l.688-.726-.005-.004-.018-.018a18 18 0 0 1-.366-.36 48.656 48.656 0 0 1-4.251-4.894c-1.163-1.542-2.31-3.284-3.162-5.06-.857-1.786-1.386-3.543-1.386-5.135h-2c0 2.007.658 4.073 1.583 6 .929 1.935 2.157 3.793 3.369 5.4a51 51 0 0 0 4.744 5.411l.107.103.006.006.002.002c.001 0 .001.001.689-.725m-8.5-16.197C11.5 11.911 15.335 8 20 8V6C14.172 6 9.5 10.867 9.5 16.803zM20 8c4.665 0 8.5 3.912 8.5 8.803h2C30.5 10.867 25.828 6 20 6z",
  mask: "url(#pin-in-button_svg__b)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pin-in-button_svg__a",
  width: 27,
  height: 34,
  x: 6.5,
  y: 7,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5033_2610"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5033_2610",
  result: "shape"
})))));
export default SvgPinInButton;